import React, { createContext, useContext } from 'react'
import { Table, Button, Icon } from 'semantic-ui-react'
import { useSelector } from 'react-redux'
import styles from './alert-view.module.css'
import IntelMsg from '../../../ItelMsg'
import DynamicAlertSettings from './dynamicAlertSettings'

export const AlertViewContext = createContext()

const AssetView = () => {
  const { setViewAlert, viewAlert, assetData } = useContext(AlertViewContext)

  const { deviceData } = useSelector((store2) => ({
    deviceData: store2.deviceData.deviceData,
  }))

  const tankTypes = {
    SQ: 'Square',
    REC: 'Rectangle',
    CVC: 'Vertical Cylinder',
    HC: 'Horizontal Cylinder',
    HDE: 'Horizontal Dish Ends',
  }

  const goBack = () => {
    setViewAlert(false)
  }

  const calculateSamplingRate = (settings) => {
    const rate = settings.substr(3, 2)
    return rate[0] === '0' ? '1' : '15'
  }

  return (
    <div>
      <div className={styles.container}>
        <IntelMsg id="dynamicAlertSettings" />
      </div>
      <Table definition>
        <Table.Body>
          <Table.Row>
            <Table.Cell width={3}>Tank Name</Table.Cell>
            <Table.Cell>
              {deviceData['device label'] === '' ||
              deviceData['device label'] === null
                ? deviceData['device name']
                : deviceData['device label']}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell width={3}>Tank Type</Table.Cell>
            <Table.Cell>{tankTypes[`${assetData.type}`]}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell width={3}>
              Tank Volume{' '}
              <span style={{ fontSize: '15px' }}>
                (cm <sup>3</sup>)
              </span>
            </Table.Cell>
            <Table.Cell>
              {assetData.volume ? (
                assetData.volume
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              ) : (
                <i style={{ color: 'grey' }}>No Volume Value Set</i>
              )}
            </Table.Cell>
          </Table.Row>

          {assetData.type !== 'HC' ? (
            <Table.Row>
              <Table.Cell width={3}>Tank Height (cm)</Table.Cell>
              <Table.Cell>
                {assetData.height ? (
                  assetData.height
                ) : (
                  <i style={{ color: 'grey' }}>No Height Value Set</i>
                )}
              </Table.Cell>
            </Table.Row>
          ) : null}

          {assetData.type !== 'CVC' ? (
            <Table.Row>
              <Table.Cell width={3}>Tank Length (cm)</Table.Cell>
              <Table.Cell>
                {assetData.length ? (
                  assetData.length
                ) : (
                  <i style={{ color: 'grey' }}>No Width Value Set</i>
                )}
              </Table.Cell>
            </Table.Row>
          ) : null}

          {assetData.type === 'SQ' || assetData.type === 'REC' ? (
            <Table.Row>
              <Table.Cell width={3}>Tank Width (cm)</Table.Cell>
              <Table.Cell>
                {assetData.width ? (
                  assetData.width
                ) : (
                  <i style={{ color: 'grey' }}>No Width Value Set</i>
                )}
              </Table.Cell>
            </Table.Row>
          ) : null}

          {assetData.type === 'CVC' || assetData.type === 'HC' ? (
            <Table.Row>
              <Table.Cell width={3}>Tank Diameter</Table.Cell>
              <Table.Cell>
                {assetData.diameter ? (
                  assetData.diameter
                ) : (
                  <i style={{ color: 'grey' }}>No Diameter Value Set</i>
                )}
              </Table.Cell>
            </Table.Row>
          ) : null}

          <Table.Row>
            <Table.Cell width={3}>Sampling Rate Per Minute</Table.Cell>
            <Table.Cell>
              {assetData.settings ? (
                calculateSamplingRate(assetData.settings)
              ) : (
                <i style={{ color: 'grey' }}>No Sampling Rate Value Set</i>
              )}
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>

      <DynamicAlertSettings
        deviceDetails={assetData}
        viewAlert={viewAlert}
        setViewAlert={setViewAlert}
      />
      <br />
      <Button
        style={{ background: '#303D54', color: 'white' }}
        icon
        labelPosition="left"
        onClick={() => goBack()}
      >
        <Icon name="arrow left" />
        <IntelMsg id="back" />
      </Button>
      <br />
    </div>
  )
}

export default AssetView
